export default "__VITE_ASSET__BETWaq5I__"